import React, { useEffect, useState } from "react"
import { Drawer, Box, IconButton, Typography, Button, FormControlLabel, Checkbox, Tab, Tabs, Tooltip } from '@mui/material';
import { CloseSquare, ArrowCircleRight, Trash } from 'iconsax-react';
import styles from './view-card.module.scss';
import { observer } from "mobx-react";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}


const ManageContactsMenu = observer(({ show, setShow, window, uiStore, cardId }) => {

    const container = window !== undefined ? () => window().document.body : undefined;
    const { userCards, connection, addCardToConnections, updateConnection, cards, removeCard } = uiStore;
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const onConfirmConCards = () => {
        setShow(false);
    };

    const onConfirmMyCards = () => {
        updateConnection();
        setShow(false);
    };

    const onRemoveCard = (cardId) => {
        removeCard(cardId);
    };

    useEffect(() => {
        uiStore?.getConnection(cardId);
    }, [cardId, show, uiStore])

    return (
        <Drawer
            container={container}
            variant="temporary"
            open={show}
            onClose={() => setShow(false)}
            ModalProps={{
                keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
                display: { xs: 'block', sm: 'block' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', maxWidth: '370px', width: '90%' },
            }}
        >
            <Box className={styles.mobileMenuHeader}>
                <Box sx={{ mt: 2 }}>
                    <Typography fontSize={18} fontWeight='700'>Manage Connection</Typography>

                    <Tabs value={value} onChange={handleChange}>
                        <Tab label="My Cards" />
                        <Tab label="Contact Cards" />
                    </Tabs>


                </Box>
                <IconButton sx={{ ml: 2, mr: 1 }} onClick={() => setShow(false)}>
                    <CloseSquare
                        size="36"
                        color='#242333'
                        variant='Bold'
                    />
                </IconButton>
            </Box>
            <TabPanel value={value} index={0}>

                <Typography color='#888888'>Contact has Access to the following cards</Typography>

                <Box className={styles.cardsCheckbox}>
                    {userCards?.map(card => (
                        <FormControlLabel
                            key={card._id}
                            control={
                                <Checkbox
                                    value={card._id}
                                    checked={connection.includes(card._id)}
                                />
                            }
                            onChange={() => addCardToConnections(card._id)}
                            label={card.name}
                        />
                    ))}
                </Box>

                <Box sx={{ position: 'fixed', bottom: '0px', padding: '20px 0', width: '315px', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant="contained" color='secondary' endIcon={
                        <ArrowCircleRight
                            size="24"
                            variant="Bulk"
                        />
                    }
                        onClick={onConfirmMyCards}
                    >
                        Save
                    </Button>
                </Box>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <Typography color='#888888'>You have Access to the following contact cards</Typography>

                <Box sx={{ ml: 2.5 }}>
                    {cards?.map(card => (
                        <Box key={card._id} className={styles.manageContactCard}>
                            <Typography>{card.name}</Typography>
                            <Tooltip title="Remove Card">
                                <IconButton onClick={() => onRemoveCard(card._id)}>
                                    <Trash size="24" variant="Bulk" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    ))}
                </Box>

                <Box sx={{ position: 'fixed', bottom: '0px', padding: '20px 0', width: '315px', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant="contained" color='secondary' endIcon={
                        <ArrowCircleRight
                            size="24"
                            variant="Bulk"
                        />
                    }
                        onClick={onConfirmConCards}
                    >
                        Save
                    </Button>
                </Box>
            </TabPanel>

        </Drawer>
    );
});

export default ManageContactsMenu;